module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-bw.644d6e10.png";